import classNames from 'classnames';
import React from 'react';
import Button, { ButtonProps } from "../Button";

export interface ButtonGroupProps extends React.HTMLAttributes<HTMLElement> {
  className?: string;

  /**
   * ボタンの横幅
   */
  width?: "3s" | "2s" | "s" | "m" | "ml" | "l" | "2l" | "full";
}

const ButtonGroup: React.FC<ButtonGroupProps> & {
  Button: typeof ButtonGroupButton
} = ({
  width,
  className,
  children,
  ...props
}) => {
    const classes = classNames(
      "uc-toggle-group",
      className,
      width && `uc-button--w${width === "full" ? "-" : ""}${width}`,
    )

    return (
      <div className={classes} {...props}>
        {children}
      </div>
    );
  };

export interface ButtonGroupButtonProps extends ButtonProps {
  /**
   * ボタンがアクティブ(選択状態)
   */
  isActive?: boolean;
}

const ButtonGroupButton: React.FC<ButtonGroupButtonProps> = ({
  className,
  isActive = false,
  ...props
}) => {
  const classes = classNames(
    className,
    isActive && "uc-button--active"
  );

  return <Button className={classes} {...props} />;
}

ButtonGroup.Button = ButtonGroupButton;

export default ButtonGroup;